export enum ToolPaletteTypeEnum {
    NotSpecified,
    MainMenuBar,
    ConfigurationPage
}
